import { format, subDays } from 'date-fns';
import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as PlaceholderImage } from '../../assets/images/no-mobile-support.svg';

import { OrganizationSummaryList } from '../../components';
import { DateFormatsEnum } from '../../constants/date';
import { useHeaderDispatch } from '../../contexts/HeaderInfo';
import useWindowSize from '../../hooks/useWindowSize';
import { fetchOrganizationSummariesRequest, setActiveOrganizationSummary } from '../../store/actions/dashboard';
import { selectActiveSummary, selectOrganizationSummaries } from '../../store/selectors/dashboard';

import styles from './DistributorDashboardContainer.module.scss';

const DistributorDashboardContainer = () => {
  const dispatch = useDispatch();
  const { setHeader } = useHeaderDispatch();
  const { medium } = useWindowSize();

  const organizationSummaries = useSelector(selectOrganizationSummaries);
  const activeSummary = useSelector(selectActiveSummary);

  const handleItemClick = useCallback(
    (id: string) => {
      dispatch(setActiveOrganizationSummary(id === activeSummary ? null : id));
    },
    [activeSummary, dispatch],
  );

  const fetchOrganizationSummaries = useCallback(() => {
    dispatch(
      fetchOrganizationSummariesRequest({
        date_range: {
          from: format(subDays(new Date(), 30), DateFormatsEnum.Start),
          to: format(new Date(), DateFormatsEnum.End),
        },
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    setHeader?.({ title: 'Distributor dashboard' });
  }, [setHeader]);

  useEffect(() => {
    fetchOrganizationSummaries();
  }, [fetchOrganizationSummaries]);

  return (
    <div className={styles.dashboardWrapper}>
      {medium ? (
        <div className={styles.noSupport}>
          <span className={styles.label}>
            <span>Unfortunately, we do not support this feature for mobile users. </span>
            <span>Please, visit desktop version to use the dashboard.</span>
          </span>
          <PlaceholderImage className={styles.image} />
        </div>
      ) : (
        <div className={styles.information}>
          <OrganizationSummaryList
            className={styles.summaryList}
            summaryList={organizationSummaries || null}
            activeSummary={activeSummary}
            onItemClick={handleItemClick}
          />
        </div>
      )}
    </div>
  );
};

export default DistributorDashboardContainer;
